import { call, put, select, take, takeEvery } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { SELF_SERVICE } from 'constants/ExtensionConstants';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { searchExtras } from 'modules/checklists/actions/dashboard';
import { selectGroup } from 'modules/groups/actions';
import { FETCH_GROUP_SUCCESS, FETCH_GROUP_FAILURE, SELECT_GROUP } from 'modules/groups/actionTypes';
import { getGroupsByExtension, getSelectedGroupId } from 'modules/groups/selectors';
import { getBaseParameters } from 'modules/selfServices/selectors/config';

export function* checkSelectedGroup() {
  const selectedGroupId = yield select(getSelectedGroupId);
  const groups = yield select(state => getGroupsByExtension(state, SELF_SERVICE));
  const isGroupLoaded = groups.some(({ id }) => id === selectedGroupId);

  if (!isGroupLoaded && groups[0]) {
    yield put(selectGroup(groups[0].id));
    yield take(FETCH_GROUP_SUCCESS, FETCH_GROUP_FAILURE);
  }
}

const refreshDashboard = (group = false) =>
  function* refresh() {
    const params = yield select(state => getBaseParameters(state, group));
    if (params.groupId || params.dealerId) {
      yield put(searchExtras(params, { source: 'extras-dashboard' }));
    }
  };

function* initializeDealerDashboard() {
  const refreshFn = refreshDashboard();
  yield call(refreshFn);
  yield takeEvery(SELECT_DEALER, refreshFn);
}

function* initializeGroupDashboard() {
  const refreshFn = refreshDashboard(true);
  yield call(checkSelectedGroup);
  yield call(refreshFn);
  yield takeEvery([SELECT_DEALER, SELECT_GROUP], refreshFn);
}

export default function* extrasDashboardSaga() {
  yield scopeToPage([PATH.GROUP_EXTRA_DASHBOARD], initializeGroupDashboard);
  yield scopeToPage([PATH.DEALER_EXTRA_DASHBOARD], initializeDealerDashboard);
}
